module.exports = __webpack_public_path__ + "media/images/autopilot_preview-email_only-m-326d7d3e45b4d01622c4af84095bc250.svg";